export const hexToRgb = (hex) => {
    // Remove the leading '#' if present
    hex = hex === null || hex === void 0 ? void 0 : hex.replace(/^#/, "");
    // Parse the hex value into its RGB components
    let bigint = parseInt(hex, 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;
    return `${r}, ${g}, ${b}`;
};
